import { useMutation } from '@tanstack/react-query';
import { redirect } from 'react-router-dom';
import { getRivirTCService, acceptRivirTCService } from 'services/rivir-tc';
import { isAuthed } from 'utils/common/session';

export const rivirTCQueryKeys = {
  all: ['rivir-tc'],
  detail: (userId) => [...rivirTCQueryKeys.all, 'detail', parseInt(userId)],
};

export const prefetchEulaQuery = async (queryClient, userId) => {
  await queryClient.prefetchQuery({
    queryKey: rivirTCQueryKeys.detail(userId),
    queryFn: async () => {
      const response = await getRivirTCService();
      if (!response?.isSuccess) {
        throw new Error('Failed to fetch EULA');
      }
      return response.data;
    },
  });
};

export const getRivirTCFromCache = (queryClient, userId) => {
  return queryClient.getQueryData(rivirTCQueryKeys.detail(userId));
};

export const ensureRivirTCData = async (queryClient, userId) => {
  // Early return if not authenticated or no userId
  if (!isAuthed() || !userId) {
    throw new Error('User not authenticated or userId missing');
  }

  try {
    const rivirTCData = await queryClient.ensureQueryData({
      queryKey: rivirTCQueryKeys.detail(userId),
      queryFn: async () => {
        const response = await getRivirTCService();
        return response?.data;
      },
    });

    return rivirTCData;
  } catch (error) {
    throw error;
  }
};

export const validateRivirTCFlow = async ({
  queryClient,
  userId,
  returnUrl,
}) => {
  try {
    const rivirTCData = await ensureRivirTCData(queryClient, userId);
    const isRivirTCAccepted = rivirTCData?.isAccepted;

    if (!isRivirTCAccepted) {
      throw redirect(
        `/check-rivir-tc?returnUrl=${encodeURIComponent(returnUrl)}`
      );
    }
  } catch (error) {
    if (error?.status === 302 || error instanceof Response) {
      throw error;
    }
  }
};

export const useAcceptedRivirTC = () => {
  return useMutation({
    mutationFn: acceptRivirTCService,
  });
};
